<div class="brand-header bg-white border-t-20 desktop:border-t-40 border-b-4 border-dmp-green border-b-dmp-blue font-oswald">
  <div class="brand-header__row max-w-container mx-auto px-5 pt-2.5 pb-1 desktop:px-0 desktop:py-8 flex items-center">
    <div class="w-1/2">
      <img class="brand-header__logo w-full max-w-logo my-1.5" [src]="brandLogo" alt="Dr. Marty">
    </div>
    <div class="brand-header__phone w-1/2 flex items-center justify-end gap-2.5 font-bold text-lg text-dmp-blue">
      <img class="w-5 desktop:w-auto" [src]="CDN_IMAGES.PHONE" alt="">
      <span [innerHTML]="dynamicPhoneNumber"></span>
    </div>
  </div>
</div>
